import { Observable } from 'rxjs';

import { Container, Service } from '../../../symphony';

import {
	AxiosInstanceType,
	SlAxiosInstanceService,
} from '../../private/services/sl-axios-instance.service';
import { IApiUrls, IHostsConfigs, HeadersAuthorizationType } from '../global';
import { SlApiContext } from '../../private/api-context';
import { AuthLevel, Authorize } from '../../private/authorize.decorator';
import {
	constructConfig,
	constructUrl,
} from '../../private/utils/httpParamsUtils';
import {
	ILandingPageApi,
	ILandingPageResponse,
} from '../../private/learn-engine-api/landing-page-api.interface';

@Service()
export class LandingPageApi implements ILandingPageApi {
	private environmentUrl: string;

	private axiosInstance: AxiosInstanceType;

	private version: string;

	constructor() {
		this.environmentUrl = (
            Container.take('global', 'envUrl') as IApiUrls
		).landingPageApiHost;

		this.version = (Container.take('global', 'hostsConfigs') as IHostsConfigs)
            	.landingPageApi?.version || '';

		this.axiosInstance = Container.take(
			SlApiContext,
			SlAxiosInstanceService,
		).axios;
	}

    @Authorize(AuthLevel.public)
	public getLandingPage(alias: string): Observable<ILandingPageResponse> {
		return this.axiosInstance.get(
			constructUrl(
				this.environmentUrl,
				`static-pages/${alias}.json`,
				this.version,
			),
			constructConfig({
				authorization: HeadersAuthorizationType.None,
			}),
		);
	}
}

export * from '../../private/learn-engine-api/landing-page-api.interface';
